import { useMemo, useState } from "react";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import {  Container} from "@mui/material";

import FeaturesSlideItem from "components/Home/child-components/FeaturesSlideItem";

const responsive = {
  desktop: {
    breakpoint: {
      max: 3000,
      min: 1024
    },
    items: 3,
    partialVisibilityGutter: 40
  },
  mobile: {
    breakpoint: {
      max: 464,
      min: 0
    },
    items: 1,
    partialVisibilityGutter: 30
  },
  tablet: {
    breakpoint: {
      max: 1024,
      min: 464
    },
    items: 2,
    partialVisibilityGutter: 30
  }
};

function displayMobileNavbar() {
  if (window.innerWidth < 768) {
    return "mobile"
  } else if (window.innerWidth < 992) {
    return "tablet"
  } else {
    return "desktop"
  }
}
const Features = ({data, parseContent}) => {
  const deviceType = useMemo(() => displayMobileNavbar(), []);
  const [CurrentIndex, setCurrentIndex] = useState(0);
  return (
    <div id="Features" style={{padding : "20px 0"}} className="text-center">
      <Container sx={{p:{xs:1,md:"16px"}}} maxWidth="sm">
        <div className="section-title">
        <h2 style={{textAlign:"center"}}>{data ? data.title : "...loading"}</h2>
        </div>
        
        <Carousel
          additionalTransfrom={0}
          arrows
          // autoPlaySpeed={3000}
          centerMode={false}
          className=""
          containerClass="container-with-dots"
          dotListClass="slick-dots"
          draggable
          focusOnSelect={false}
          infinite={false}
				  // autoPlay
          itemClass=""
          keyBoardControl
          minimumTouchDrag={80}
          pauseOnHover
          renderArrowsWhenDisabled={false}
          renderButtonGroupOutside={false}
          renderDotsOutside={false}
          responsive={responsive}
          showDots
          rewind={true}
          rewindWithAnimation={true}
          rtl={false}
          sliderClass=""
          slidesToSlide={1}
          swipeable
          beforeChange={(nextSlide, { currentSlide, onMove }) => {
            setCurrentIndex(nextSlide);
          }}
          >
              {data
                ? data.cards?.map((d, i) => (
                    <FeaturesSlideItem key={`${d.title}-${i}`} 
                      to={d.link ? d.link.slug : ""}
                      img={`${process.env.REACT_APP_PUBLIC_URL}/img/features/${d.img}`}
                      title={d.title}
                      content={parseContent(d.text.substring(0,150))}
                      active={deviceType === "desktop" && CurrentIndex +1 === i }
                      />
                ))
              : "Loading..."}
          </Carousel>
      </Container>
    </div>
  );
};
export default Features;